import axios from 'axios';
const base = `https://www.mapout.com/mapout-node/api/contactus`;
export const getContactData = () => axios.get(`${base}`);
